import { createRoot } from '@wordpress/element';
import SettingsPanel from '@components/Settings/SettingsPanel';

const App = () => {
  return <SettingsPanel />;
};

const el = document.getElementById('blockbite-settings');
const root = createRoot(el);
root.render(<App />);
